import React, { useState } from 'react'
import { image } from '../../../app/utils/common/image';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { checkUser, clearUserData, register, selectAuthStatus } from '../../../redux/Slices/authSlice';
import { AppDispatch } from '../../../redux/store';
import LOGINUPPERSIDE from '../../../assets/images/login.svg';
import Input from '../../atoms/Input/Input';
import Button from '../../atoms/Button/Button';
import Loader from '../../atoms/Loader/Loader';
// OTP FLOW DISABLED TEMPORARILY
// import VerifyLoginOtp from '../VerifyLoginOtp/VerifyLoginOtp';
import sendFirebaseEvent from '../../../app/firebase/sendFirebaseEvent';
import './LoginForm.scss'

const LoginForm = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [userName, setUserName] = useState<string>('');
  const [countryCode, setCountryCode] = useState<string>('+91');
  const [activeButton, setActiveButton] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [registerModal, setRegisterModal] = useState<boolean>(false);

  // OTP FLOW DISABLED TEMPORARILY
  // const [showOtpModal, setShowOtpModal] = useState<boolean>(false);
  // const [otp, setOtp] = useState<string[]>(["", "", "", ""]);
  // const [isOtpSent, setIsOtpSent] = useState(false);

  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const authStatus = useSelector(selectAuthStatus);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      registerModal ? handleRegister() : handleCheckUser();
    }
  };

  // Checks if the phone number is registered.
  // Existing user → tokens returned, navigate to /profile directly.
  // New user → show registration form prefilled with phone number.
  const handleCheckUser = () => {
    setLoading(true);
    setErrorMessage('');
    sendFirebaseEvent('check_user_button', 'user_action', 'checkUser', 'Continue Button Clicked');
    dispatch(checkUser({ phoneNumber, countryCode })).then((action: any) => {
      setLoading(false);
      if (action.type === 'auth/checkUser/fulfilled') {
        const { success, data } = action.payload;
        if (success && data?.user_exists) {
          localStorage.setItem('access_token', data.token_details.access_token);
          localStorage.setItem('refresh_token', data.token_details.refresh_token);
          setErrorMessage('');
          navigate('/profile');
        } else if (success && !data?.user_exists) {
          setRegisterModal(true);
          setErrorMessage('');
        }
      } else if (action.type === 'auth/checkUser/rejected') {
        setErrorMessage(action.payload?.error?.message || 'Something went wrong. Please try again.');
      }
    });
  };

  // OTP FLOW DISABLED TEMPORARILY — handleSendOtp / handleVerifyOtp kept for future re-enablement
  /*
  const handleSendOtp = () => { ... };
  const handleVerifyOtp = () => { ... };
  */

  const handleRegister = () => {
    if (!userName || !phoneNumber) {
      setErrorMessage('Please enter your name and phone number.');
      return;
    }

    setLoading(true);
    setErrorMessage('');
    dispatch(clearUserData());
    dispatch(register({ username: userName, countryCode, phoneNumber }))
      .then((action: any) => {
        setLoading(false);
        const { success, error } = action.payload;
        if (success) {
          setErrorMessage('');
          const { data } = action.payload;
          localStorage.setItem('access_token', data?.token_details.access_token);
          localStorage.setItem('refresh_token', data?.token_details.refresh_token);
          navigate('/profile');
        } else if (error) {
          const errMsg = error.message || 'Failed to register';
          setErrorMessage(errMsg);
        }
      })
      .catch((err: any) => {
        setLoading(false);
        setErrorMessage('Error during registration: ' + err.message);
      });
  };

  const handlePhoneChange = (event: any) => {
    if (event.target.value.length <= 10) {
      setPhoneNumber(event.target.value);
      setActiveButton(event.target.value.length === 10);
      setErrorMessage('');
    }
  };

  const handleUserNameChange = (event: any) => {
    setUserName(event.target.value);
    setErrorMessage('');
  };

  return (
    <div className=''>
      <div className='flex login-container' onKeyDown={handleKeyDown} tabIndex={0}>
        <img src={window.innerWidth > 750 ? image.WEBLOGO : image.LOGOBGCOLOR} className='login-bg-img'
          draggable="false"
          onContextMenu={(e) => e.preventDefault()} />
        <div className='flex login-upper-container'>
          <img src={LOGINUPPERSIDE} className='login-upper' draggable="false"
            onContextMenu={(e) => e.preventDefault()} />
          {registerModal ? (
            <div className="register-text">Register</div>
          ) : (
            <img src={image.LOGINTEXT} className="login-text" draggable="false"
              onContextMenu={(e) => e.preventDefault()} />
          )}
          <div className='border-blue'>
            <div className='border-dark-blue'>
              <div className='border-orange'>
                <div className='border-yellow'>
                  <div className='border-inner-blue'>
                    <div className={`${!registerModal ? 'login-dimension' : 'register-dimension'}`}>
                      {!loading ? (
                        <div className='Phone-number-container'>
                          <div>
                            {registerModal && (
                              <div style={{ marginBottom: "12px" }}>
                                <Input
                                  label='Name'
                                  placeholder='Enter your alias'
                                  type="text"
                                  id="username"
                                  name="username"
                                  value={userName}
                                  onChange={handleUserNameChange}
                                />
                              </div>
                            )}
                            <Input
                              label='Phone Number'
                              placeholder='Enter phone number'
                              type="tel"
                              id="tel"
                              name="phone-no"
                              value={phoneNumber}
                              onChange={handlePhoneChange}
                              info='Enter your phone number to get started'
                              ShowInfo={!registerModal}
                              classNameInfo="get-help-add-on-hover"
                              disabled={registerModal} />
                            <div>
                              {errorMessage && <div className='error-message'>{errorMessage}</div>}
                            </div>
                          </div>
                          <div>
                            {!registerModal
                              ? <Button onClick={handleCheckUser} buttonTitle="Continue" />
                              : <Button onClick={handleRegister} buttonTitle="Sign up" />}
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-center justify-center">
                          <Loader height={'320px'} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginForm
